import { Trans } from '@lingui/react/macro';

import { type VendorActivityDataType } from '@/api/vendor';
import PlusIcon from '@/assets/svg/bx-plus.svg?react';
import { Badge, Text } from '@/components/typography';

type Props = {
  titleWidth: number;
  removedVendors: VendorActivityDataType[];
  onAddVendor?: (vendor: VendorActivityDataType) => void;
};

const VendorFitScoringTableActions = ({ titleWidth, removedVendors, onAddVendor }: Props) => {
  return (
    <div className="flex gap-2">
      <Text
        className="mt-1.5 text-right whitespace-nowrap"
        style={{ width: titleWidth }}
        variant="body2"
      >
        <Trans>Add Vendor:</Trans>
      </Text>
      <div className="flex flex-wrap gap-2">
        {removedVendors.map((vendor) => (
          <Badge
            key={vendor.vendor.id}
            className="cursor-pointer not-[&:hover]:bg-transparent!"
            size="large"
            color="success"
            onClick={() => onAddVendor?.(vendor)}
          >
            <div className="flex items-center gap-1.5">
              <PlusIcon width={18} height={18} />
              <Trans>
                {vendor.vendor.name} - {vendor.vendor.channel?.name}
              </Trans>
            </div>
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default VendorFitScoringTableActions;
